import actions from '@/store/modules/option/actions.js'
import getters from '@/store/modules/option/getters.js'
import mutations from '@/store/modules/option/mutations.js'

/**
 * @returns {object}
 */
const getDefaultState = () => ({
  options: [],
  optionMetaFilters: {},
  latestDeliveryAssigned: null,
  optionsPaginatedPage: 1,
  optionsPaginatedLimit: 20,
  hasReachedOptionsPaginatedEnd: false,
  isUploadingOption: false
})

export default {
  actions,
  getters,
  mutations,
  state: getDefaultState()
}

export { getDefaultState }
